import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/catalogs";
import Form from "./form";
import ItemsList from "./itemsList";
import List from "./list";
import Show from "./show";

const OrganizationCatalogs = (props) => {
    const { match, location, history, canEditBooks } = props;
    const rootUrl = `${match.path}/list`;
    const back = () => history.push(rootUrl);
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                <Route
                    exact
                    path={rootUrl}
                    render={() => (
                        <List
                            {...props}
                            isTable
                            transition="full"
                            title="Справочники"
                            createBtnText="Создать справочник"
                            nofilter
                        />
                    )}
                />
                <Route
                    exact
                    path={`${rootUrl}/:id/items`}
                    render={(rest) => (
                        <ItemsList
                            {...rest}
                            nofilter
                            transition="full"
                            title="Элементы справочника"
                            back={back}
                            source={source}
                        />
                    )}
                />
                <Route
                    path={`${rootUrl}/:id`}
                    render={(rest) => (
                        <Show {...rest} transition="full" title="Справочник" back={back} source={source} />
                    )}
                />
                {canEditBooks() && (
                    <Route
                        path={`${match.path}/new`}
                        render={() => (
                            <Form
                                {...props}
                                transition="full"
                                title="Создание справочника"
                                back={back}
                                submit={source.applyOrganizationCatalog}
                            />
                        )}
                    />
                )}
            </Switch>
        </div>
    );
};

export default OrganizationCatalogs;
